import api from '@/services/api'

export default {
  state: {
    forms: [],
    order: 1,
  },

  mutations: {
    ADD_FORMS(state, forms) {
      state.forms = forms
    },

    CHANGE_ORDER(state, order) {
      state.order = order
    },
  },

  actions: {
    async getForms({ commit }, data) {
      try {
        const response = await api.get('/forms')
        const forms = response && response.data ? response.data : []

        commit('ADD_FORMS', forms)
      } catch (error) {
        throw error
      }
    },

    changeOrder: ({ commit }, order) => {
      commit('CHANGE_ORDER', order)
    },
  },

  getters: {
    forms: (state) => state.forms,
    order: (state) => state.order,
  },
}
